let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("l7nfE")]).then(() => parcelRequire('ncXSS'));